var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarSharpcomponent = function SvgStarSharpcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 8.544 3.298 2.4L8.036 7.07l3.297-2.347H7.29L6 .722l-1.289 4H.667L3.964 7.07l-1.262 3.875L6 8.544Z",
    fill: "#70D6BA"
  })));
};
export default SvgStarSharpcomponent;